import { CountryCode } from '~shared/constants/country-code.enum';

export const SupportPhoneNumbers = {
  [CountryCode.Germany]: {
    b2b: '0211-911 91 005',
    b2c: '0211 - 911 94200',
    subsidiary: '0211-911 91 005',
    telesales: '0211 - 8694 3727',
  },
  [CountryCode.Spain]: {
    b2b: '+34 91-0387956',
    b2c: '+34 91-0387960',
    subsidiary: '0211-911 91 005',
    telesales: '900 759 896',
  },
  [CountryCode.Italy]: {
    b2b: '+39-02-89734969',
    b2c: '+39 0289734908',
    subsidiary: '0211-911 91 005',
    telesales: '0383398128',
  },
  [CountryCode.Portugal]: {
    b2b: '+351 211451870',
    b2c: '+351 211451830',
    subsidiary: '0211-911 91 005',
    telesales: '',
    disclaimer: true,
  },
  [CountryCode.Netherlands]: {
    b2b: '020-7956593',
    b2c: '020-7956594',
    subsidiary: '+31 (0)20 020-7956593',
    telesales: '',
  },
  [CountryCode.France]: {
    b2b: '01 70 70 04 98',
    b2c: '01 70 06 01 70',
    subsidiary: '0211-911 91 005',
    telesales: '03 67 21 31 76',
  },
};
